/* 🤖 this file was generated by script */
export const wsolidiconAlarmClock = {
  name: 'alarm_clock',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M5.7 3.7a1 1 0 0 0-1.4-1.4l-3 3a1 1 0 0 0 1.4 1.4zM19.7 2.3a1 1 0 1 0-1.4 1.4l3 3a1 1 0 1 0 1.4-1.4z"/><path fill="currentColor" fill-rule="evenodd" d="M12 22a9 9 0 0 0 5.62-1.97l1.67 1.68a1 1 0 0 0 1.42-1.42l-1.68-1.67a9 9 0 1 0-14.06 0l-1.68 1.67a1 1 0 1 0 1.42 1.42l1.67-1.68A9 9 0 0 0 12 22m1-13a1 1 0 1 0-2 0v4q0 .42.3.7l2 2a1 1 0 0 0 1.4-1.4L13 12.58z" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
